import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { ExtendedInfoIcon } from '../../../shared/svg/components';
import { getFeaturePriceText } from '../../../utils/currencyFormatter';
import IsNullOrUndefined from '../../../utils/ObjectUtils';

const SummaryFeature = ({ categoryName, feature, disabled }) => {
    const { settings, currentUnit } = useSelector(state => state.configurator);

    if (disabled) return null;

    return (
      <div className="summary-feature-printing">
        <div className="category-name">{categoryName}</div>
        <div className="container-image-texts">
          <div className="image-mask">
            <div className="image-container">
              <img src={`${settings.thumbs_base_url}/${feature.thumb}`} alt="" />
            </div>
          </div>
          <div className="feature-text-container">
            <div className="feature-title-name-container">
              <div className="feature-title">Opción {feature.order}</div>
              <div className="feature-name">{feature.name}</div>
              {!IsNullOrUndefined(feature.description) && feature.description.length > 0 ? (
                <div className="container-icon-description-extended">
                  <div className="icon-container"><ExtendedInfoIcon className="icon" /></div>
                  <div className="description">{feature.description}</div>
                </div>
              ) : null}
            </div>
            <div className="feature-price">{getFeaturePriceText(feature, currentUnit)}</div>
          </div>
        </div>
      </div>
    );
};

SummaryFeature.propTypes = {
    categoryName: PropTypes.string.isRequired,
    feature: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        description: PropTypes.string,
        thumb: PropTypes.string,
        order: PropTypes.number,
        hasPrice: PropTypes.bool,
        price: PropTypes.string,
    }).isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default SummaryFeature;
